import { useCMSYCMMstore } from '@/service/stores/cm/cmsy/CMM.store'
import { dayjs } from '@gsretail/gssm-util'

// dB에서 시스템 날짜 [14자리] 조회
export const gfnSysDate = async (format) => {
  try {
    let returnValue
    const CMSYCMMstore = useCMSYCMMstore()
    const resItem = await CMSYCMMstore.actionHttpCmSyCmmCommRetrieveSysDate()
    if (format === undefined) {
      returnValue = resItem + '' || '00000000000000'
    } else {
      returnValue = dayjs(resItem).format(format)
    }
    return returnValue
  } catch (error) {
    return '00000000000000'
  }
}

// dB에서 시스템 날짜 [8자리] 조회
export const gfnSysdate8 = async () => {
  return ''
}

// 영업일자 조회
export const gfnSaledate = async () => {
  return ''
}

// 전표처리요청서 오류 수정 요청의 건, 첨부파일ID를 생성한다
export const gfnAttFileIdSeq = async () => {
  return ''
}
